import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import AppRouter from './AppRouter';
import { PostHogProvider } from 'posthog-js/react'

const isTrackingEnabled = window.location.hostname !== 'localhost';

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  session_recording: {
    maskAllInputs: false,
  },
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isTrackingEnabled ? (
      <PostHogProvider
        apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
        options={options}
      >
        <AppRouter />
      </PostHogProvider>
    ) : (
      <AppRouter />
    )}
  </React.StrictMode>
);

reportWebVitals();
